// extracted by mini-css-extract-plugin
export var smallSpinner = "_qt-0";